module.exports = __webpack_public_path__ + "img/plant_3_small.01e96fcb.webp";